import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Story from "@/components/site/Story";
import FilmSection from "@/components/site/FilmSection";
import Embroidery from "@/components/site/Embroidery";
import Legacy from "@/components/site/Legacy";
import Footer from "@/components/site/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-ink text-cream font-body antialiased" data-testid="hilmays-site">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <FilmSection />
        <Embroidery />
        <Legacy />
      </main>
      <Footer />
    </div>
  );
}
